import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Dialog,
  Typography,
  makeStyles,
  FormHelperText,
} from "@material-ui/core";
import { useForm, Controller } from "react-hook-form";
import Controls from "../../components/controls";
import Iconify from "../../components/Iconify";

import LoadingScreen from "../../components/LoadingScreen";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiFormControl-root": {
      width: "100%",
    },
  },
  error: {
    marginLeft: 8,
    marginTop: 0,
    color: "#d73131",
    fontWeight: 600,
    fontSize: 13,
  },
}));

export default function AddNewBAImagesForm(props) {
  const {
    onAddPicture,
    fromAddPicture,
    loadingSave,
    recordproducts = [],
  } = props;
  const { reset, errors, watch, control, handleSubmit } = useForm();

  const file = watch("file");
  const classes = useStyles();
  const [imageToUploadUrl, setImageToUploadUrl] = useState("");

  const onSubmit = (data) => {
    onAddPicture(data);
  };

  useEffect(() => {
    if (file) {
      setImageToUploadUrl(window.URL.createObjectURL(file));
    } else {
      setImageToUploadUrl("");
    }
  }, [file]);

  const recordproductOptions = () =>
    recordproducts.map((recordproduct) => ({
      id: recordproduct.id,
      title: recordproduct?.invoiceItem?.data?.name,
    }));

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={classes.root}>
      <Grid
        container
        spacing={5}
        sx={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid item xs={fromAddPicture === "proceduresBAOthers" ? 4 : 6}>
          <Controller
            name="name"
            control={control}
            defaultValue={null}
            render={({ onChange, value }) => (
              <Controls.Input label="Name" value={value} onChange={onChange} />
            )}
            rules={{ required: "Name is required" }}
          />
          <FormHelperText className={classes.error} id="name-helper-text">
            {errors.name ? errors.name.message : " "}
          </FormHelperText>
        </Grid>
        <Grid item xs={fromAddPicture === "proceduresBAOthers" ? 4 : 6}>
          <Controller
            name="record_products"
            control={control}
            defaultValue={[]}
            render={({ onChange, value }) => (
              <Controls.MultipleSelect
                styleProp
                label="Procedures"
                options={recordproductOptions()}
                value={value}
                onChange={(value) => onChange(value)}
              />
            )}
            rules={{
              validate: (value) => value.length > 0 || "Procedures is required",
            }}
          />
          <FormHelperText
            className={classes.error}
            id="record_products-helper-text"
          >
            {errors.record_products ? errors.record_products.message : " "}
          </FormHelperText>
        </Grid>
        {fromAddPicture === "proceduresBAOthers" ? (
          <Grid item xs={4}>
            <Controller
              name="type"
              control={control}
              defaultValue=""
              render={({ onChange, value }) => (
                <Controls.Select
                  label="Type"
                  options={[
                    {
                      id: "Before",
                      title: "Before",
                    },
                    {
                      id: "After",
                      title: "After",
                    },
                  ]}
                  value={value}
                  onChange={(value) => onChange(value)}
                />
              )}
              rules={{ required: "Type is required" }}
            />
            <FormHelperText className={classes.error} id="type-helper-text">
              {errors.type ? errors.type.message : " "}
            </FormHelperText>
          </Grid>
        ) : (
          ""
        )}
        <Grid item xs={12}>
          <Controller
            name="file"
            control={control}
            defaultValue={null}
            render={({ onChange, value }) => (
              <Controls.DropzoneDialog
                st={{
                  background: "none",
                  color: "rgb(97, 106, 141)",
                  borderRadius: 18,
                  boxShadow: "none",
                }}
                label={
                  <Box>
                    <Box
                      style={{
                        background: "#f2fdfd",
                        boxShadow: "rgb(53 64 82 / 10%) 0px 0px 14px 0px",
                        borderRadius: 20,
                        width: "60vw",
                        height: "38vh",
                        position: "relative",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center", // Centers the image vertically
                      }}
                    >
                      {imageToUploadUrl && imageToUploadUrl !== "" ? (
                        <img
                          src={imageToUploadUrl}
                          alt={"Attach"}
                          style={{
                            maxHeight: "35vh",
                            maxWidth: "40vw",
                            borderRadius: 20,
                          }}
                        />
                      ) : (
                        <div>
                          <div>
                            <Iconify
                              style={{
                                width: 200,
                                height: 200,
                                color: "#7388af",
                                marginTop: 40,
                              }}
                              icon="majesticons:image"
                            />
                          </div>
                          <div>
                            <Typography
                              style={{
                                color: "#1565c0",
                                fontFamily: "Nunito,Roboto",
                                fontWeight: 400,
                                margin: 12,
                                fontSize: "1rem",
                                fontStyle: "italic",
                              }}
                            >
                              Upload a file. Click to browse files on your
                              device.
                            </Typography>
                          </div>
                        </div>
                      )}
                    </Box>
                  </Box>
                }
                onChange={(files) => {
                  onChange(files[0]);
                }}
                value={value}
              />
            )}
            rules={{ required: "File is required" }}
          />
          <FormHelperText
            className={classes.error}
            id="file-helper-text"
            style={{ textAlign: "center" }}
          >
            {errors.file ? errors.file.message : " "}
          </FormHelperText>
        </Grid>
      </Grid>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          margin: 25,
          marginTop: 10,
        }}
      >
        <Controls.Button
          variant="contained"
          color="primary"
          text="Submit"
          style={{ width: "20%" }}
          type="submit"
          disabled={loadingSave}
        />
      </div>

      <Dialog
        open={loadingSave}
        PaperProps={{
          style: {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        }}
      >
        {<LoadingScreen />}
      </Dialog>
    </form>
  );
}
